import {
  ConsentGroupsDto,
  ConsentLinkDto,
  TermDto,
  TermGroupDto,
  TermIdentityDto,
  TermResponseDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';
import type {
  ConsentFormSubmissionRequest,
  ConsentLinkCreationRequest,
  IdentitySubmissionRequest,
  TermResponseRequest,
} from '@act/shared/types';

export const consentRequests = {
  getConsentGroups: EndpointDefinition.get<TermGroupDto[], { userId: string }>({
    name: 'getConsentGroups',
    route: '/consent',
  }),
  getAllTerms: EndpointDefinition.get<TermDto[], null>({
    name: 'getAllTerms',
    route: '/consent/allTerms',
  }),
  updateConsent: EndpointDefinition.post<
    TermResponseDto[],
    TermResponseRequest,
    { userId: string }
  >({
    name: 'updateConsent',
    route: '/consent',
  }),
  createConsentLink: EndpointDefinition.post<
    ConsentLinkDto,
    ConsentLinkCreationRequest,
    null
  >({
    name: 'createConsentLink',
    route: '/consent/links',
  }),
  getConsentLink: EndpointDefinition.get<ConsentLinkDto, { key: string }>({
    name: 'getConsentLink',
    route: '/consent/links/:key',
  }),
  getConsentForm: EndpointDefinition.get<ConsentGroupsDto, { key: string }>({
    name: 'getConsentForm',
    route: '/consent/form/',
  }),
  postIdentity: EndpointDefinition.post<
    TermIdentityDto,
    IdentitySubmissionRequest,
    {}
  >({
    name: 'postIdentity',
    route: '/consent/identity',
  }),
  postIdentityForm: EndpointDefinition.post<
    TermIdentityDto,
    IdentitySubmissionRequest,
    {}
  >({
    name: 'postIdentityForm',
    route: '/consent/form/identity',
  }),
  postTermForm: EndpointDefinition.post<
    ConsentGroupsDto,
    ConsentFormSubmissionRequest,
    {}
  >({
    name: 'postTermForm',
    route: '/consent/form/',
  }),
};
